// extracted by mini-css-extract-plugin
export default {"container":"style_container__mRWaC","top_container":"style_top_container__dXcIJ","main":"style_main__YtWTb"};